module.exports = __webpack_public_path__ + "src/assets/img/cmdProg6.30aec91a.svg";